import { Component, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { PayLoadPix } from 'src/app/model/PayLoadPix';
import { AuthService } from 'src/app/seguranca/auth.service';
import { FinanceiroService } from '../financeiro.service';
import { DebitosPix } from 'src/app/model/DebitosPix';

@Component({
  selector: 'app-extrato-financeiro',
  templateUrl: './extrato-financeiro.component.html',
  styleUrls: ['./extrato-financeiro.component.css']
})
export class ExtratoFinanceiroComponent implements OnInit {

  token: any
  payLoad: any
  idSocio = 0;
  idEmpresa = 0;
  dataInicio = new Date();
  dataFim = new Date();
  espelho: any
  debitos: DebitosPix[] = [];

  qrCodePix = "";
  qrCodeLink = "";
  jwsPayLoad: any;

  payLoadPix = new PayLoadPix();
  payLoadQrCode = '';
  valorTotalDebito = 0;

  renovarLoginDialog = false;
  aguardeDialog = false;
  pixDialog = false;

  constructor(
    private financeiroService: FinanceiroService,
    private erro: ErrorHandler,
    private auth: AuthService,
    private jwtDecoder: JwtHelperService,
    private rota: ActivatedRoute,
    private toasty: ToastrService
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('access_token_xmanager');
    this.payLoad = this.jwtDecoder.decodeToken(this.token);
    window.scrollTo(0, 0);
    this.idSocio = this.rota.snapshot.params.id;
    this.idEmpresa = this.payLoad.empresa.id;
    this.buscarDebitosPorIdSocio();    

    this.payLoadPix.pixKey = "35376276000153";
    this.payLoadPix.description = "Mensalidade / débito em aberto";
    this.payLoadPix.merchantName = "ASSOCIACAO DOS CB E SD";
    this.payLoadPix.merchantCity = "MACEIO";
    this.payLoadPix.txid = this.payLoad.user_name;
    this.payLoadPix.description = "Mensalidade / débito em aberto";
  }

  espelhoPorSocio() {
    if (!this.auth.isAccessTokenInvalido()) {
      let opcaoRelatorio = 0;

      if (!this.dataInicio) {
        this.toasty.warning('INFORME A DATA DE INÍCIO PARA O EXTRATO FINANCEIRO!', 'ATENÇÃO !');
        opcaoRelatorio = 1;
      }

      if (!this.dataFim) {
        this.toasty.warning("INFORME A DATA FINAL PARA O EXTRATO FINANCEIRO !", "ATENÇÃO !");
        opcaoRelatorio = 1;
      }

      if (opcaoRelatorio == 0) {
        this.aguardeDialog = true;
        this.financeiroService.espelhoPorSocio(this.idSocio, this.idEmpresa, this.dataInicio, this.dataFim, this.token).subscribe(
          (response: Blob) => {
            this.aguardeDialog = false;
            const url = window.URL.createObjectURL(response);
            window.open(url + '', 'modalRelatorioSocio', 'height=600,width=700,toolbar=no,scrollbars=no');
          }, erro => {
            this.erro.handleError(erro);
            this.aguardeDialog = false;
          });
      }

    } else {
      this.renovarLoginDialog = true;
    }
  }

  buscarDebitosPorIdSocio() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true
      this.financeiroService.buscarDebitosPorIdSocio(this.idSocio, this.token).subscribe(
        (dados: any) => {
          this.debitos = dados;
          let valores = this.debitos.map(d => d.valor);
          this.valorTotalDebito = valores.reduce((somar, numero) => somar + numero, 0);
          this.aguardeDialog = false;
        },
        erro => {
          this.erro.handleError(erro);
        });
    } else {
      this.renovarLoginDialog = true;
    }
  }

  abrirDialogPagamentoPix() {
    if (!this.auth.isAccessTokenInvalido()) {
      //let strValor = this.valorTotalDebito.toLocaleString("pt-BR",{minimumFractionDigits:2});
      //strValor = strValor.replace(',','.');
      //this.payLoadPix.amount = strValor;

      /*
      let jwsPayload = new JwsPayload();
      jwsPayload.versao = '1.0.0';
      jwsPayload.chave = this.payLoad.empresa.chavePix;
      jwsPayload.txid = this.payLoad.id;

      this.aguardeDialog = true;
      this.financeiroService.criarPixPayLoad(jwsPayload, this.token).subscribe(
        (dados: any) => {
          this.jwsPayLoad = dados;
          let strValor = this.jwsPayLoad.valor.original.toLocaleString("pt-BR",{minimumFractionDigits:2});
          strValor = strValor.replace(',','.');
          this.payLoadPix.amount = strValor;
          this.payLoadPix.url = "http://204.93.216.69:8084/aplicativoassomal/pix/"+this.jwsPayLoad.txid;

          this.payLoadPix.merchantName = this.payLoad.empresa.razaoSocial.substring(0,17);
          let cidade = this.payLoad.empresa.cidade.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          this.payLoadPix.merchantCity = cidade;
          this.payLoadPix.txid = this.jwsPayLoad.txid;

          this.payLoadQrCode = this.payLoadPix.getPayLoad();
          this.qrCodePix = this.payLoadQrCode;

          

          this.pixDialog = true;
          this.aguardeDialog = false;
        }, erro => {
          this.erro.handleError(erro);
          this.aguardeDialog = false;
        });
      */
      this.toasty.warning('EM CONSTRUÇÃO!', 'ATENÇÃO!');
    } else {
      this.renovarLoginDialog = true;
    }
  }
}
